import { render } from "./infor_list.vue?vue&type=template&id=b54b0850"
import script from "./infor_list.vue?vue&type=script&lang=js"
export * from "./infor_list.vue?vue&type=script&lang=js"

import exportComponent from "D:\\_FEproject\\aplikovanainformatika.sk\\zoneai\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__